import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'react';

const LargeAccountSetting = ({ testId, className, solid })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.00005 3.30005C3.40431 3.30005 1.30005 5.40431 1.30005 8.00005V16C1.30005 18.5958 3.40431 20.7001 6.00005 20.7001H22.7001V8.00005C22.7001 5.40431 20.5958 3.30005 18 3.30005H6.00005ZM1.30005 7.80005H22.7V9.20005H1.30005V7.80005ZM12 15C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14C11 14.5523 11.4477 15 12 15ZM17 14C17 14.5523 16.5523 15 16 15C15.4477 15 15 14.5523 15 14C15 13.4477 15.4477 13 16 13C16.5523 13 17 13.4477 17 14ZM9 14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14C7 13.4477 7.44772 13 8 13C8.55228 13 9 13.4477 9 14Z",
            fill: "currentColor"
        }) : /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: "M2 8C2 5.79086 3.79086 4 6 4H18C20.2091 4 22 5.79086 22 8V20H6C3.79086 20 2 18.2091 2 16V8Z",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M2 8C2 5.79086 3.79086 4 6 4H18C20.2091 4 22 5.79086 22 8V8H2V8Z",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                /*#__PURE__*/ jsx("circle", {
                    cx: "12",
                    cy: "13",
                    r: "1",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ jsx("circle", {
                    cx: "16",
                    cy: "13",
                    r: "1",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ jsx("circle", {
                    cx: "8",
                    cy: "13",
                    r: "1",
                    fill: "currentColor"
                })
            ]
        })
    });
};

export { LargeAccountSetting as default };
